// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_6ymIM","small":"KuT+l","first":"A7rfB","second":"-4qUm","third":"s2hkL","animate-spinner":"URUZu"};